import React from 'react'
import thq from '../assets/img/thq.png'
import aqusto from '../assets/img/aqusto.png'
import nrabbit from '../assets/img/nrabbit.png'
import { SlArrowRight } from "react-icons/sl";
import { TbCaretDownFilled } from "react-icons/tb";
import btcIcon from '../assets/img/btc-icon.png'
import ethIcon from '../assets/img/eth-icon.png'
import solIcon from '../assets/img/sol-icon.png'
import beatIcon from '../assets/img/beat-icon.png'
import pippinIcon from '../assets/img/pippin-icon.png'
import xprIcon from '../assets/img/xrp-icon.png'
import hIcon from '../assets/img/hustd-icon.png'
import fireIcon from '../assets/img/fire-icon.svg'
import Slider from 'react-slick';


export const PopularTokens = () => {
    const newTokens = [
        {id: 1, icon: aqusto, name: 'AQUSTO/USDT1', price: '0,00007504', change: '+110,01%'},
        {id: 2, icon: thq, name: 'THQ/USDT', price: '0,007504', change: '+34,18%'},
        {id: 3, icon: nrabbit, name: 'NRABBIT/USDT', price: '0,00007504', change: '+29,01%'},
        {id: 4, icon: aqusto, name: 'AQUSTO/USDT2', price: '0,00007504', change: '+110,01%'},
        {id: 5, icon: thq, name: 'THQ/USDT', price: '0,007504', change: '+34,18%'},
        {id: 6, icon: nrabbit, name: 'NRABBIT/USDT', price: '0,00007504', change: '+29,01%'},
        {id: 7, icon: aqusto, name: 'AQUSTO/USDT3', price: '0,00007504', change: '+110,01%'},
        {id: 8, icon: thq, name: 'THQ/USDT', price: '0,007504', change: '+34,18%'},
        {id: 9, icon: nrabbit, name: 'NRABBIT/USDT', price: '0,00007504', change: '+29,01%'},
    ]
    const topTokens = [
        {id: 1, name: 'BTCUSDT', price: '87 345,4', icon: btcIcon, leverage: 500, priceChange: '-2,55%'},
        {id: 2, name: 'ETHUSDT', price: '87 345,4', icon: ethIcon, leverage: 500, priceChange: '-2,55%'},
        {id: 3, name: 'SOLUSDT', price: '87 345,4', icon: solIcon, leverage: 500, priceChange: '-2,55%'},
        {id: 4, name: 'BEATUSDT', price: '87 345,4', icon: beatIcon, leverage: 500, priceChange: '-2,55%'},
        {id: 5, name: 'PIPPINUSDT', price: '87 345,4', icon: pippinIcon, leverage: 500, priceChange: '-2,55%'},
        {id: 6, name: 'XPRUSDT', price: '87 345,4', icon: xprIcon, leverage: 500, priceChange: '-2,55%'},
        {id: 7, name: 'HUSDT', price: '87 345,4', icon: hIcon, leverage: 500, priceChange: '-2,55%'},
        {id: 8, name: 'HUSDT', price: '87 345,4', icon: hIcon, leverage: 500, priceChange: '-2,55%'},
        {id: 9, name: 'BTCUSDT', price: '87 345,4', icon: btcIcon, leverage: 500, priceChange: '-2,55%'},
        {id: 10, name: 'ETHUSDT', price: '87 345,4', icon: ethIcon, leverage: 500, priceChange: '-2,55%'},
        {id: 11, name: 'SOLUSDT', price: '87 345,4', icon: solIcon, leverage: 500, priceChange: '-2,55%'},
        {id: 12, name: 'BEATUSDT', price: '87 345,4', icon: beatIcon, leverage: 500, priceChange: '-2,55%'},
        {id: 13, name: 'PIPPINUSDT', price: '87 345,4', icon: pippinIcon, leverage: 500, priceChange: '-2,55%'},
        {id: 14, name: 'XPRUSDT', price: '87 345,4', icon: xprIcon, leverage: 500, priceChange: '-2,55%'},
        {id: 15, name: 'HUSDT', price: '87 345,4', icon: hIcon, leverage: 500, priceChange: '-2,55%'},
        {id: 16, name: 'HUSDT', price: '87 345,4', icon: hIcon, leverage: 500, priceChange: '-2,55%'},
        {id: 17, name: 'BTCUSDT', price: '87 345,4', icon: btcIcon, leverage: 500, priceChange: '-2,55%'},
        {id: 18, name: 'ETHUSDT', price: '87 345,4', icon: ethIcon, leverage: 500, priceChange: '-2,55%'},
        {id: 19, name: 'SOLUSDT', price: '87 345,4', icon: solIcon, leverage: 500, priceChange: '-2,55%'},
        {id: 20, name: 'BEATUSDT', price: '87 345,4', icon: beatIcon, leverage: 500, priceChange: '-2,55%'},
        {id: 21, name: 'PIPPINUSDT', price: '87 345,4', icon: pippinIcon, leverage: 500, priceChange: '-2,55%'},
        {id: 22, name: 'XPRUSDT', price: '87 345,4', icon: xprIcon, leverage: 500, priceChange: '-2,55%'},
        {id: 23, name: 'HUSDT', price: '87 345,4', icon: hIcon, leverage: 500, priceChange: '-2,55%'},
        {id: 24, name: 'HUSDT', price: '87 345,4', icon: hIcon, leverage: 500, priceChange: '-2,55%'},
    ]
   
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
    };

    const chunkArray = (array, size) => {
        const chunks = [];
        for (let i = 0; i < array.length; i += size) {
            chunks.push(array.slice(i, i + size));
        }
        return chunks;
    };
    const chunkedTokens = chunkArray(newTokens, 3)
    const chunkedTopTokens = chunkArray(topTokens, 8)

    return (
    <div id="popular-tokens">
        <div className="container">
            <div className="popular-tokens">
                <div className="heading">
                    <h1>Самые популярные токены</h1>
                    <div className="big-grey">Торгуйте спотовыми парами 2 708 и фьючерсными парами 827</div>
                </div>
                <div className="crypto-layout">
                    <div className="market-dbl">
                        <div className="market small">
                            <div className="market-filter">
                                <div className="market-sort">Показывают рост на споте <TbCaretDownFilled size={22}/></div>
                                <div className="market-more">еще <SlArrowRight size={16}/></div>
                            </div>
                            <div className="slider-container">
                                <Slider {...settings}>
                                        {
                                            chunkedTokens.map((tokens, slideInd) => (
                                                <div className="market-tokens" key={slideInd}>
                                                    {
                                                        tokens.map(token => (
                                                            <div className="token" key={token.id}>
                                                                <div className="token-title">
                                                                    <div className="token-icon">
                                                                        <img src={token.icon} alt="" />
                                                                    </div>
                                                                    <div className="token-name">{token.name}</div>
                                                                </div>
                                                                <div className="token-data">
                                                                    <div className="token-price">{token.price}</div>
                                                                    <div className="token-change">{token.change}</div>
                                                                </div>
                                                            </div>
                                                        ))
                                                    }
                                                </div>
                                            ))
                                        }
                                </Slider>
                            </div>
                            
                            <div className="market-dots"></div>
                        </div>
                        <div className="market small">
                             <div className="market-filter">
                                <div className="market-sort">Новые</div>
                                <div className="market-more">еще <SlArrowRight size={16}/></div>
                             </div>
                             <div className="slider-container">
                                <Slider {...settings}>
                                            {
                                                chunkedTokens.map((tokens, slideInd) => (
                                                    <div className="market-tokens" key={slideInd}>
                                                        {
                                                            tokens.map(token => (
                                                                <div className="token" key={token.id}>
                                                                    <div className="token-title">
                                                                        <div className="token-icon">
                                                                            <img src={token.icon} alt="" />
                                                                        </div>
                                                                        <div className="token-name">{token.name}</div>
                                                                    </div>
                                                                    <div className="token-data">
                                                                        <div className="token-price">{token.price}</div>
                                                                        <div className="token-change">{token.change}</div>
                                                                    </div>
                                                                </div>
                                                            ))
                                                        }
                                                    </div>
                                                ))
                                            }
                                </Slider>
                             </div>
                            <div className="market-dots"></div>
                        </div>
                    </div>
                    <div className="market big">
                        <div className="market-filter">
                            <div className="market-sorts">
                                <div className="market-sort">Топ фьючерсы</div>
                                <div className="market-sort">Популярные токены</div>
                                <div className="market-sort">Alpha</div>
                                <div className="market-sort">Рекомендуемые</div>
                            </div>
                            <div className="market-more">еще <SlArrowRight size={16}/></div>
                        </div>
                        <div className="slider-container">

                        <Slider {...settings}>
                                    {
                                        chunkedTopTokens.map((tokens, slideInd) => (
                                            <div className="top-tokens" key={slideInd}>
                                                {
                                                    tokens.map(token => (
                                                        <div className="top-token" key={token.id}>
                                                          <div className="top-token-left">
                                                              <div className="token-icon">
                                                                  <img src={token.icon} alt="" />
                                                              </div>
                                                              <div className="token-head">
                                                                  <div className="token-name">{token.name} <img src={fireIcon} alt="" className='fire-icon'/></div>
                                                                  <div className="multiplier">{token.leverage}x</div>
                                                              </div>
                                                          </div>
                                                          <div className="token-info">
                                                              <div className="token-price">{token.price}</div>
                                                              <div className="token-percent">{token.priceChange}</div>
                                                              <button className='trade-btn'>Торговля</button>
                                                          </div>
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                        ))
                                    }
                            </Slider>
                        </div>
                        
                        <div className="market-dots"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}
